var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settingMain"},[_c('div',{staticClass:"title"},[_vm._v("ตั้งค่า")]),_c('Category',{staticClass:"wrapCategory",attrs:{"data":_vm.categoryData},on:{"click":_vm.categoryClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }